export enum TipoDesconto {
    DESCONTOS_PARA_MIM = 1,
    DESCONTOS_PARA_LOVERS = 2,
    MINHAS_EXPERIENCIAS = 3,
    PRODUTOS_EXCLUSIVOS = 4,
    MARKETPLACE = 5
}